import { RemoteMission } from '../../../data/usecases/mission-reviews/remote-mission'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeMissionReviews = (): RemoteMission => {
  return new RemoteMission('/public/reviews?mission=', makeAxiosHttpClient())
}

export const createReview = (): RemoteMission => {
  return new RemoteMission('/public/mission_reviews', makeAxiosHttpClient())
}
